<script lang="ts">
  import { getTextColor } from '../../helpers/sections-helper';
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let brand: GlobalProperties['brand'];
  export let isFooter = false;
  export let size = 24;

  let textColor;

  $: {
    try {
      textColor = getTextColor(
        brand.palette.colors.find(color => color.type === 'background')?.value,
      );
    } catch (err) {
      textColor = '#0E0F11';
    }
  }
</script>

<svelte:window />

{#if brand?.custom.active}
  <div class="logo {brand?.custom.aspectRatio}">
    <img src={brand?.custom.url} alt="img" />
  </div>
{/if}

{#if brand?.default.active}
  <div class="icon" style="height:{size}px; width:{size}px;">
    {#if isFooter}
      <span style={textColor !== '#0E0F11' ? 'filter:invert(1)' : ''}>
        <img
          src={brand?.default.url}
          alt="logo-img"
          height={size}
          width={size}
        />
      </span>
    {:else}
      <span style={brand.isDarkMode ? 'filter:invert(1)' : ''}>
        <img
          src={brand?.default.url}
          alt="logo-img"
          height={size}
          width={size}
        />
      </span>
    {/if}
  </div>
{/if}

<style>
  .icon {
    width: 45px;
    height: 45px;
  }

  .icon img {
    width: 100%;
    height: auto;
    cursor: pointer;
    max-height: 50px;
  }

  .logo {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 100%;
  }

  .logo.Rectangle {
    padding-top: 50px;
    max-width: 125px;
  }

  .logo.Square {
    padding-top: 125px;
    max-width: 125px;
  }

  .logo img {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: contain;
  }

  @media screen and (max-width: 767px) {
    .icon {
      max-width: 54px;
      max-height: 54px;
    }
  }
</style>
